/** Transform EventsCalendar/Load API rows for FullCalendar (dashboard — no filters). */

function parseEventRow(item, index) {
  let event = item.events || item.event || item;
  if (!event || !event.title) return null;

  const startRaw = event.start || event.startDate || event.dtFrom;
  const endRaw = event.end || event.endDate || event.dtTo || startRaw;
  if (!startRaw) return null;

  const isHoliday =
    String(event.eventType || event.type || "")
      .toLowerCase()
      .includes("holiday") ||
    String(event.eventFor || "")
      .toLowerCase()
      .includes("holiday");

  // Audience tags used by the dashboard filters (Staff / Students). Parents
  // events are shown under Students, matching the event-calendar app.
  const rawFor = event.eventFor || event.calendar || "";
  const calendars = (Array.isArray(rawFor) ? rawFor : String(rawFor).split(","))
    .map((v) => String(v).trim())
    .filter(Boolean)
    .map((v) => (v.toLowerCase() === "parents" ? "Students" : v));

  const colors = isHoliday
    ? {
        backgroundColor: "rgba(40, 199, 111, 0.12)",
        borderColor: "#28c76f",
        textColor: "#1e7e4a",
      }
    : {
        backgroundColor: "rgba(115, 103, 240, 0.1)",
        borderColor: "#7367f0",
        textColor: "#5e50ee",
      };

  const id =
    event.id ||
    item.id ||
    `dash-ev-${index}-${String(event.title).slice(0, 12)}`;

  return {
    id: String(id),
    title: String(event.title).trim(),
    start: startRaw,
    end: endRaw,
    allDay: event.allDay !== false,
    backgroundColor: colors.backgroundColor,
    borderColor: colors.borderColor,
    textColor: colors.textColor,
    extendedProps: {
      location: event.location || "",
      eventType: isHoliday ? "holiday" : "event",
      colorIndex: index % 4,
      calendars,
    },
  };
}

export function normalizeEventsCalendarLoadResponse(response) {
  let eventsData = null;
  if (
    response?.data?.status === "success" &&
    Array.isArray(response.data.data)
  ) {
    eventsData = response.data.data;
  } else if (Array.isArray(response?.data)) {
    eventsData = response.data;
  } else if (Array.isArray(response)) {
    eventsData = response;
  }
  if (!Array.isArray(eventsData)) return [];
  return eventsData
    .map((item, index) => parseEventRow(item, index))
    .filter(Boolean);
}

export function yearFromCalendarInfo(info) {
  if (!info) return new Date().getFullYear();
  if (info.view && info.view.currentStart) {
    return info.view.currentStart.getFullYear();
  }
  const startDate = info.start;
  if (startDate) {
    const mid = new Date(startDate.getTime() + 15 * 86400000);
    return mid.getFullYear();
  }
  return new Date().getFullYear();
}
